import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const TestimonialsSC = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 56px;
    margin-top: 56px;
    align-items: center;
    background: #F9FBED;

    .testimonial-title {
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 2px;
    }

    .testimonial-holder {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 60px;
        margin: 0px 120px;
        padding: 40px;
        ${NoTextSelectionStyles}
        .testimonial-card {
            background: white;
            padding: 20px;
            border-radius: 8px;
            min-height: 400px;
            box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
            transition: all 0.2s ease-in-out;
            &:hover {
               scale: 1.02;
            }
        }

        .highlight-text {
            color: white;
            font-size: 14px;
            margin-bottom: 16px;
            padding: 8px 24px;
            border-radius: 22px;
            width: fit-content;
            margin-top: -36px;
            margin-left: 10px; 
            font-weight: 500;
            letter-spacing: 1.5px;
        }

        .testimonial-text {
            font-size: 18px;
            line-height: 1.6;
            color: #444;
            padding: 0px 8px;
            text-align: justify;
        }

        .testimonial-author {
            margin-top: 12px;
            margin-left: 8px;
            font-size: 18px;
            font-weight: 600;
            display: flex;
            gap: 6px;
            flex-direction: column;
        }

        .testimonial-author span {
            font-weight: 400;
            color: #777;
        }
    }

    @media (max-width: 768px) {
        gap: 16px;
        padding: 24px;
        margin-top: 24px;

        .testimonial-title {
            font-size: 16px;
            letter-spacing: 1px;
        }

        .testimonial-holder {
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin: 0px 2px;
            padding: 2px;

            .testimonial-card {
                padding: 12px;
                margin-top: 16px;
                border-radius: 8px;
                min-height: 280px;
            }

            .highlight-text {
                font-size: 12px;
                margin-bottom: 8px;
                padding: 8px 16px;
                border-radius: 18px;
                margin-top: -26px;
                letter-spacing: 1px;
            }

            .testimonial-text {
                font-size: 12px;
                line-height: 1.6;
            }

            .testimonial-author {
                margin-top: 8px;
                margin-left: 8px;
                gap: 6px;
                flex-direction: column;
                font-size: 12px;
            }
        }
    }
`;

export default TestimonialsSC;